<div mat-dialog-content class="dialog-content">
    <div class="icon-container">
      <mat-icon class="success-icon">check_circle_outline</mat-icon>
    </div>
    <h2 class="dialog-title">Awesome!</h2>
    <p class="dialog-message">{{message1}} <br />{{message2}}</p>
  </div>
  <div mat-dialog-actions align="center">
    <button mat-raised-button color="primary" class="confirm-button" (click)="onConfirm()">OK</button>
  </div>
  